'use strict';

var React = require('react');

var SvgCancelMajor = function SvgCancelMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.707 4.707a1 1 0 0 0-1.414-1.414l-5.293 5.293-5.293-5.293a1 1 0 0 0-1.414 1.414l5.293 5.293-5.293 5.293a1 1 0 1 0 1.414 1.414l5.293-5.293 5.293 5.293a1 1 0 0 0 1.414-1.414l-5.293-5.293 5.293-5.293Z"
  }));
};

exports.SvgCancelMajor = SvgCancelMajor;
